import { TDeviceReadings } from "src/data/devices/types/deviceTypes"

/**
 * Type guard to filter out number[] entries and ensure we only process
 * objects with datetime. number[] entries cannot be plotted on a time-series
 * chart since they lack datetime information.
 *
 * Note: Filtering is safe because:
 * - number[] entries have no datetime, so they can't be plotted anyway
 * - The old code with ?? "" would have created invalid dates (new Date(""))
 * - The schema requires datetime: string, so valid objects always have it
 */
export function hasDatetime(
  value: TDeviceReadings["values"][number]
): value is {
  value: number
  datetime: string
  min?: number
  max?: number
} {
  return (
    !Array.isArray(value) &&
    "datetime" in value &&
    typeof (value as { datetime?: unknown }).datetime === "string" &&
    (value as { datetime: string }).datetime !== ""
  )
}
